import React, { useState, useEffect, useMemo } from "react";
import { compareBintiSoarHomes } from "../services/soar";
import Select from "../common/Select";
import Modal from "react-bootstrap/Modal";
import { Card } from "react-bootstrap";
import { toast } from "react-toastify";
import FieldDisplay from "../common/FieldDisplay";
import { CCPLUpdate, writeErrorLog } from "../services/soar";
const org =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "ReactLive"
    : process.env.REACT_APP_ENVIRONMENT === "Test"
    ? "ReactTest"
    : process.env.REACT_APP_ENVIRONMENT === "Development"
    ? "ReactDev"
    : "ReactIdk";

function Compare() {
  const [data, setData] = useState([]);
  const [differences, setDifferences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedState, setSelectedState] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedHome, setSelectedHome] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedSoarMember, setSelectedSoarMember] = useState(null);
  const [selectedSoarAddress, setSelectedSoarAddress] = useState(null);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  useEffect(() => {
    if (selectedState) {
      setLoading(true);
      compareBintiSoarHomes(selectedState).then((res) => {
        setData(res);
        setLoading(false);
      });
    }
  }, [selectedState]);

  useMemo(() => {
    if (data.length > 0) {
      console.log("Data", data);
      const diff = [];

      //filter each item in data and in the HomeData array for homes that hava a binti home where the type is "RenewalApplication" and the status is "Applying"
      const filteredData = data.filter(
        (home) =>
          home.HomeData.sort(
            (a, b) => new Date(b.createdon) - new Date(a.createdon)
          ).filter(
            (item) =>
              item.source === "BINTI" &&
              item.type === "RenewalApplication" &&
              item.status === "applying"
          ).length > 0
      );

      console.log("Filtered Data", filteredData);

      filteredData.forEach((home) => {
        const soarHome = home.HomeData.filter(
          (item) => item.source === "SOAR"
        )[0];
        const bintiHome = home.HomeData.filter(
          (item) => item.source === "BINTI"
        )[0];

        // write function for comparing the two homes
        // for each member in the bintiHome.members array
        // create a boolean variable called differencesFound and set it to false;
        // look for a member in the soarHome.members array with the same firstname, middlename, lastname, mobilephone, emailaddress1, telephone1
        // if a match is not found, set differencesFound to true
        // for each address in the bintiHome.addresses array
        // look for an address in the soarHome.addresses array with the same streetaddress, city, state, postalcode
        // if a match is not found, set differencesFound to true
        // if differencesFound is true, add the home to the diff array

        if (soarHome && bintiHome) {
          let differencesFound = false;
          let memberDifferences = [];
          bintiHome.members.forEach((member) => {
            const soarMember = soarHome.members.filter(
              (item) =>
                item.firstname?.trim() === member.firstname?.trim() &&
                item.middlename?.trim() === member.middlename?.trim() &&
                item.lastname?.trim() === member.lastname?.trim() &&
                item.mobilephone
                  ?.replaceAll("+1", "")
                  ?.replaceAll("(", "")
                  ?.replaceAll(")", "")
                  ?.replaceAll("-", "")
                  ?.replaceAll(" ", "")
                  ?.trim() ===
                  member?.telephone1
                    ?.replaceAll("+1", "")
                    ?.replaceAll("(", "")
                    ?.replaceAll(")", "")
                    ?.replaceAll("-", "")
                    ?.replaceAll(" ", "")
                    ?.trim() &&
                item.emailaddress1?.trim() === member.emailaddress1?.trim()
            )[0];
            if (!soarMember) {
              differencesFound = true;
              memberDifferences.push(member);
            }
          });

          let addressDifferences = [];
          bintiHome.addresses.forEach((address) => {
            if (address.streetaddress && address.city) {
              const soarAddress = soarHome.addresses.filter(
                (item) =>
                  item.streetaddress?.toLowerCase()?.trim() ===
                    address.streetaddress?.toLowerCase()?.trim() &&
                  item.city?.toLowerCase()?.trim() ===
                    address.city?.toLowerCase()?.trim() &&
                  item.postalcode?.trim() === address.postalcode?.trim()
              )[0];
              if (!soarAddress) {
                differencesFound = true;
                addressDifferences.push(address);
              }
            }
          });
          if (differencesFound) {
            home.memberDifferences = memberDifferences;
            home.addressDifferences = addressDifferences;
            diff.push(home);
          }
        }

        if (!soarHome && bintiHome) {
          home.memberDifferences = bintiHome.members;
          home.addressDifferences = bintiHome.addresses;
          home.HomeData.push({
            source: "SOAR",
            members: [],
            addresses: [],
          });
          diff.push(home);
        }
      });

      setDifferences(diff);
      console.log("Differences", diff);
    }
  }, [data]);

  const clearData = () => {
    setSelectedAddress(null);
    setSelectedHome(null);
    setSelectedMember(null);
    setSelectedSoarMember(null);
    setSelectedSoarAddress(null);
  };

  const formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return ["(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return null;
  };

  const updateData = (destination, field, value, type) => {
    let obj = { ...destination };
    obj[field] = value;
    if (type === "member") {
      setSelectedSoarMember(obj);
    }
    if (type === "address") {
      setSelectedSoarAddress(obj);
    }
  };

  const saveRecord = (type) => {
    const obj =
      type === "member"
        ? {
            firstname: {
              type: "string",
              value: selectedSoarMember.firstname || null,
            },
            middlename: {
              type: "string",
              value: selectedSoarMember.middlename || null,
            },
            lastname: {
              type: "string",
              value: selectedSoarMember.lastname || null,
            },
            mobilephone: {
              type: "string",
              value: selectedSoarMember.mobilephone || null,
            },
            telephone1: {
              type: "string",
              value: selectedSoarMember.telephone1 || null,
            },
            emailaddress1: {
              type: "string",
              value: selectedSoarMember.emailaddress1 || null,
            },
            emailaddress2: {
              type: "string",
              value: selectedSoarMember.emailaddress2 || null,
            },
          }
        : {
            ccx_line1: {
              type: "string",
              value: selectedSoarAddress.streetaddress || null,
            },
            ccx_city: {
              type: "string",
              value: selectedSoarAddress.city || null,
            },
            ccx_postalcode: {
              type: "string",
              value: selectedSoarAddress.postalcode || null,
            },
          };
    const url = `https://safyportalapi.azurewebsites.net/api/SOARU2?entityName=${
      type === "member" ? "contact" : "ccx_fostercarehomeaddress"
    }&id=${
      type === "member"
        ? selectedSoarMember.contactid
        : selectedSoarAddress.fostercarehomeaddressid
    }&obj=${encodeURIComponent(JSON.stringify(obj))}&userName=${
      safyInfo.user.domainName
    }&org=https://ccplive.safy.org`;

    const logData = {
      Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
      API: "SOAR API",
      APIBody: obj,
      URL: url,
      Org: org,
      Application: "React Portal",
    };

    CCPLUpdate(url, 1, logData)
      .then((res) => {
        if (res.resultset) {
          console.log("Update Result", res.resultset);
          toast.success(
            `${type === "member" ? "Contact" : "Address"} Updated Successfully`
          );
        }
      })
      .catch((error) => {
        console.log("Error", error);
        toast.error("Error Updating Contact");
      });
  };

  const openSoarHome = (id) => {
    const url = `https://ccplive.safy.org/main.aspx?etc=10221&extraqs=formid%3da28fd99b-80b7-46a0-9dbc-e83d4d6dffda&id=${id}&pagetype=entityrecord`;
    window.open(url, "Address");
  };

  const openInBinti = (id) => {
    const url = `https://family.binti.com/admin/applications/${id}`;
    window.open(url, "Binti");
  };

  const attributeCompare = (
    label,
    soarObject,
    bintiObject,
    attribute,
    type
  ) => {
    return (
      <div className="row mb-4">
        <div className="col-6 fw-bold">
          <FieldDisplay label={label} value={soarObject[attribute]} />
        </div>
        <div className="col-6">
          {soarObject[attribute] !== bintiObject[attribute] && (
            <div
              className="btn btn-sm btn-primary"
              onClick={() =>
                updateData(soarObject, attribute, bintiObject[attribute], type)
              }
            >
              <i className="fas fa-arrow-left me-2"></i>
              {bintiObject[attribute]}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <Modal
        size="xl"
        show={isOpen}
        animation={false}
        onHide={() => {
          clearData();
          setIsOpen(false);
        }}
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>{`Update Member`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedMember && (
            <>
              <Card className="card-safy mb-4">
                <Card.Header className="p-0 ps-2 bg-safy1-1 text-white">
                  Binti Member
                </Card.Header>
                <Card.Body className="p-2- card-body-safy">
                  <FieldDisplay
                    label="First Name"
                    value={selectedMember.firstname}
                  />
                  <FieldDisplay
                    label="Middle Name"
                    value={selectedMember.middlename}
                  />
                  <FieldDisplay
                    label="Last Name"
                    value={selectedMember.lastname}
                  />
                  <FieldDisplay
                    label="Mobile Phone"
                    value={formatPhoneNumber(selectedMember.mobilephone)}
                  />
                  <FieldDisplay
                    label="Telephone"
                    value={formatPhoneNumber(selectedMember.telephone1)}
                  />
                  <FieldDisplay
                    label="Email"
                    value={selectedMember.emailaddress1}
                  />
                </Card.Body>
              </Card>
              <Select
                name="soarMember"
                label="Select SOAR Contact record to update with the above info"
                options={selectedHome.HomeData.filter(
                  (item) => item.source === "SOAR"
                )[0].members.map((member) => ({
                  name: `${member.firstname} ${member.lastname}`,
                  _id: member.contactid,
                }))}
                value={selectedSoarMember || ""}
                onChange={(e) => {
                  setSelectedSoarMember(
                    selectedHome.HomeData.filter(
                      (item) => item.source === "SOAR"
                    )[0].members.filter(
                      (member) => member.contactid === e.currentTarget.value
                    )[0]
                  );
                }}
              />
              {selectedSoarMember && (
                <>
                  <div className="row mb-4">
                    <div className="col-6">
                      <div className="rounded bg-success text-white h5 p-2 m-1">
                        SOAR Contact Data
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="rounded bg-primary text-white h5 p-2 m-1">
                        Binti Data
                      </div>
                    </div>
                  </div>
                  {attributeCompare(
                    "First Name",
                    selectedSoarMember,
                    selectedMember,
                    "firstname",
                    "member"
                  )}
                  {attributeCompare(
                    "Middle Name",
                    selectedSoarMember,
                    selectedMember,
                    "middlename",
                    "member"
                  )}
                  {attributeCompare(
                    "Last Name",
                    selectedSoarMember,
                    selectedMember,
                    "lastname",
                    "member"
                  )}
                  <div className="row mb-4">
                    <div className="col-6 fw-bold">
                      <FieldDisplay
                        label="Mobile Phone"
                        value={selectedSoarMember.mobilephone}
                      />
                    </div>
                    <div className="col-6">
                      {selectedMember.mobilephone &&
                        formatPhoneNumber(selectedMember.mobilephone) !==
                          selectedSoarMember.mobilephone && (
                          <div
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              updateData(
                                selectedSoarMember,
                                "mobilephone",
                                formatPhoneNumber(selectedMember.mobilephone),
                                "member"
                              )
                            }
                          >
                            Mobile<i className="fas fa-arrow-left mx-2"></i>
                            {formatPhoneNumber(selectedMember.mobilephone)}
                          </div>
                        )}
                      {selectedMember.telephone1 &&
                        formatPhoneNumber(selectedMember.telephone1) !==
                          selectedSoarMember.mobilephone && (
                          <div
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              updateData(
                                selectedSoarMember,
                                "mobilephone",
                                formatPhoneNumber(selectedMember.telephone1),
                                "member"
                              )
                            }
                          >
                            Telephone 1
                            <i className="fas fa-arrow-left mx-2"></i>
                            {formatPhoneNumber(selectedMember.telephone1)}
                          </div>
                        )}
                      {selectedMember.telephone2 &&
                        formatPhoneNumber(selectedMember.telephone2) !==
                          selectedSoarMember.mobilephone && (
                          <div
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              updateData(
                                selectedSoarMember,
                                "mobilephone",
                                formatPhoneNumber(selectedMember.telephone2),
                                "member"
                              )
                            }
                          >
                            Telephone 2
                            <i className="fas fa-arrow-left mx-2"></i>
                            {formatPhoneNumber(selectedMember.telephone2)}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-6 fw-bold">
                      <FieldDisplay
                        label="Home Phone"
                        value={selectedSoarMember.telephone1}
                      />
                    </div>
                    <div className="col-6">
                      {selectedMember.mobilephone &&
                        formatPhoneNumber(selectedMember.mobilephone) !==
                          selectedSoarMember.telephone1 && (
                          <div
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              updateData(
                                selectedSoarMember,
                                "telephone1",
                                formatPhoneNumber(selectedMember.mobilephone),
                                "member"
                              )
                            }
                          >
                            Mobile<i className="fas fa-arrow-left mx-2"></i>
                            {formatPhoneNumber(selectedMember.mobilephone)}
                          </div>
                        )}
                      {selectedMember.telephone1 &&
                        formatPhoneNumber(selectedMember.telephone1) !==
                          selectedSoarMember.telephone1 && (
                          <div
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              updateData(
                                selectedSoarMember,
                                "telephone1",
                                formatPhoneNumber(selectedMember.telephone1),
                                "member"
                              )
                            }
                          >
                            Telephone 1
                            <i className="fas fa-arrow-left mx-2"></i>
                            {formatPhoneNumber(selectedMember.telephone1)}
                          </div>
                        )}
                      {selectedMember.telephone2 &&
                        formatPhoneNumber(selectedMember.telephone2) !==
                          selectedSoarMember.telephone1 && (
                          <div
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              updateData(
                                selectedSoarMember,
                                "telephone1",
                                formatPhoneNumber(selectedMember.telephone2),
                                "member"
                              )
                            }
                          >
                            Telephone 2
                            <i className="fas fa-arrow-left mx-2"></i>
                            {formatPhoneNumber(selectedMember.telephone2)}
                          </div>
                        )}
                    </div>
                  </div>
                  {attributeCompare(
                    "Email 1",
                    selectedSoarMember,
                    selectedMember,
                    "emailaddress1",
                    "member"
                  )}
                  {attributeCompare(
                    "Email 2",
                    selectedSoarMember,
                    selectedMember,
                    "emailaddress2",
                    "member"
                  )}
                  <div className="row">
                    <div className="col-6">
                      <div
                        className="btn btn-success"
                        onClick={() => {
                          saveRecord("member");
                        }}
                      >
                        Update SOAR Contact
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {selectedAddress && (
            <>
              <Card className="card-safy mb-4">
                <Card.Header className="p-0 ps-2 bg-safy1-1 text-white">
                  Binti Address
                </Card.Header>
                <Card.Body className="p-2- card-body-safy">
                  <FieldDisplay
                    label="Street Address"
                    value={selectedAddress.streetaddress}
                  />
                  <FieldDisplay label="City" value={selectedAddress.city} />
                  <FieldDisplay label="State" value={selectedAddress.state} />
                  <FieldDisplay
                    label="Zip Code"
                    value={selectedAddress.postalcode}
                  />
                  <FieldDisplay label="Type" value={selectedAddress.type} />
                </Card.Body>
              </Card>
              <Select
                name="soarMember"
                label="Select SOAR Address record to update with the above info"
                options={selectedHome.HomeData.filter(
                  (item) => item.source === "SOAR"
                )[0].addresses.map((address) => ({
                  name: `${address.streetaddress} ${address.city}`,
                  _id: address.fostercarehomeaddressid,
                }))}
                value={selectedSoarAddress || ""}
                onChange={(e) => {
                  setSelectedSoarAddress(
                    selectedHome.HomeData.filter(
                      (item) => item.source === "SOAR"
                    )[0].addresses.filter(
                      (address) =>
                        address.fostercarehomeaddressid ===
                        e.currentTarget.value
                    )[0]
                  );
                }}
              />
              {selectedSoarAddress && (
                <>
                  <div className="row mb-4">
                    <div className="col-6">
                      <div className="rounded bg-success text-white h5 p-2 m-1">
                        SOAR Contact Data
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="rounded bg-primary text-white h5 p-2 m-1">
                        Binti Data
                      </div>
                    </div>
                  </div>
                  {attributeCompare(
                    "Street Address",
                    selectedSoarAddress,
                    selectedAddress,
                    "streetaddress",
                    "address"
                  )}
                  {attributeCompare(
                    "City",
                    selectedSoarAddress,
                    selectedAddress,
                    "city",
                    "address"
                  )}
                  {attributeCompare(
                    "Zip Code",
                    selectedSoarAddress,
                    selectedAddress,
                    "postalcode",
                    "address"
                  )}
                  <div className="row">
                    <div className="col-6">
                      <div
                        className="btn btn-success"
                        onClick={() => {
                          saveRecord("address");
                        }}
                      >
                        Update SOAR Address
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
      <>
        <Select
          className="col-6"
          name="stateSelection"
          label="Select State"
          onChange={(e) => {
            setData([]);
            setDifferences([]);
            setSelectedState(e.currentTarget.value);
          }}
          options={[
            { name: "Alabama", _id: "Alabama" },
            { name: "Colorado", _id: "Colorado" },
            { name: "Indiana", _id: "Indiana" },
            { name: "Kentucky", _id: "Kentucky" },
            { name: "Nevada", _id: "Nevada" },
            { name: "Ohio", _id: "Ohio" },
            { name: "South Carolina", _id: "SouthCarolina" },
          ]}
          value={selectedState || ""}
        />

        {loading === true ? (
          <div className="p-2 m-2 text-primary">Loading Data</div>
        ) : (
          differences.map((home, index) => (
            <div
              className="border bg-light p-2 m-2"
              key={`${home.id}--${index}`}
            >
              <div className="h4">{home.id}</div>

              <div className="h5">
                <i
                  className="fas fa-home text-primary me-2"
                  onClick={() =>
                    openInBinti(
                      home.HomeData.filter((item) => item.source === "BINTI")[0]
                        .applicationid
                    )
                  }
                />
                Binti Differences
              </div>
              {home.memberDifferences.map((member, index) => (
                <div
                  className="row m-1 bg-danger text-white rounded p-2"
                  key={`${home}Binti${member.contactid}--${index}`}
                >
                  <div className="col-1 ">{member.firstname}</div>
                  <div className="col-1">{member.middlename}</div>
                  <div className="col-2">{member.lastname}</div>
                  <div className="col-2">{member.mobilephone}</div>
                  <div className="col-3">{member.emailaddress1}</div>
                  <div className="col-2">{member.telephone1}</div>
                  <div className="col-1 ">
                    <i
                      title="Add"
                      className="fas fa-pencil float-end p-1"
                      onClick={() => {
                        setSelectedHome(home);
                        setSelectedMember(member);
                        setSelectedAddress(null);
                        setIsOpen(true);
                      }}
                    ></i>
                  </div>
                </div>
              ))}
              {home.addressDifferences.map((address, index) => (
                <div
                  className="row m-1 bg-warning rounded p-2"
                  key={`${home.id}B${index}`}
                >
                  <div className="col-4">{address.streetaddress}</div>
                  <div className="col-3">{address.city}</div>
                  <div className="col-3">{address.postalcode}</div>
                  <div className="col-1">{address.type}</div>
                  <div className="col-1">
                    <i
                      title="Add"
                      className="fas fa-pencil float-end p-1"
                      onClick={() => {
                        setSelectedHome(home);
                        setSelectedMember(null);
                        setSelectedAddress(address);
                        setIsOpen(true);
                      }}
                    ></i>
                  </div>
                </div>
              ))}

              {home.HomeData.filter((h) => h.source === "SOAR")[0].members
                .length > 0 &&
              home.HomeData.filter((h) => h.source === "SOAR")[0].addresses
                .length > 0 ? (
                <div className="safy-border-2 rounded px-2 mt-4 bg-white">
                  <div className="h5 mt-2">
                    <i
                      className="fas fa-home text-success me-2"
                      onClick={() =>
                        openSoarHome(
                          home.HomeData.filter((h) => h.source === "SOAR")[0]
                            .fostercarehomeguid
                        )
                      }
                    />
                    SOAR DATA
                  </div>
                  <div className="h6">Members</div>
                  {home.HomeData.filter(
                    (h) => h.source === "SOAR"
                  )[0].members.map((member, index) => (
                    <div
                      className="row m-1"
                      key={`${home.id}SOAR${member.contactid}--${index}`}
                    >
                      <div className="col-1">{member.firstname}</div>
                      <div className="col-1">{member.middlename}</div>
                      <div className="col-2">{member.lastname}</div>
                      <div className="col-2">{member.mobilephone}</div>
                      <div className="col-3">{member.emailaddress1}</div>
                      <div className="col-2">{member.telephone1}</div>
                    </div>
                  ))}
                  <div className="h6 mt-4">Addresses</div>
                  {home.HomeData.filter(
                    (h) => h.source === "SOAR"
                  )[0].addresses.map((address, index) => (
                    <div className="row m-1" key={`${home.id}S${index}`}>
                      <div className="col-4">{address.streetaddress}</div>
                      <div className="col-3">{address.city}</div>
                      <div className="col-3">{address.postalcode}</div>
                      <div className="col-1">{address.type}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="safy-border-2 rounded px-2 mt-4 bg-white">
                  <div className="h5 mt-2">SOAR Data</div>
                  <div className="text-danger fw-bold">
                    Home does not exist in SOAR. Please create a new home in
                    SOAR manually
                    <i
                      className="fas fa-home ms-2 text-success"
                      onClick={() =>
                        window.open(
                          "https://ccplive.safy.org/main.aspx?etc=10221&extraqs=newWindow=true&pagetype=entityrecord",
                          "New Foster Home"
                        )
                      }
                    ></i>
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </>
    </div>
  );
}

export default Compare;
